import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { Box, IconButton, Popover, Typography } from "@mui/material";
import { omit } from "lodash-es";
import { useRef } from "react";

import type { ToolbarProps } from "./props";
import type { IconButtonProps, TypographyProps } from "@mui/material";
import type { FC, ReactNode } from "react";

export const ToolbarDropDown: FC<
  ToolbarProps &
    IconButtonProps & {
      icon?: React.JSX.Element;
      heading: string;
      open: boolean;
      setOpen: (open: boolean) => void;
      children: ReactNode;
      headingTypographyProps?: TypographyProps;
      "data-analytics-id": string;
    }
> = ({
  icon,
  heading,
  disabled,
  open,
  setOpen,
  children,
  "data-analytics-id": dataAnalyticsId,
  ...props
}) => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <IconButton
        data-analytics-id={dataAnalyticsId}
        disabled={disabled}
        data-testid={`toolbar-${heading.toLocaleLowerCase()}`}
        ref={anchorRef}
        onClick={() => setOpen(!open)}
        {...props}
      >
        <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
          {icon}
          {heading && (
            <Typography
              sx={[
                {
                  display: "inline-block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "80px",
                },
                ...(Array.isArray(props.headingTypographyProps?.sx)
                  ? props.headingTypographyProps.sx
                  : [props.headingTypographyProps?.sx]),
              ]}
              {...(omit(props.headingTypographyProps, "sx") ?? {})}
            >
              {heading}
            </Typography>
          )}
          <KeyboardArrowDown />
        </Box>
      </IconButton>
      <Popover
        // oxlint-disable-next-line react/refs -- MUI anchorEl needs the DOM node; the popover only opens after the anchor has mounted
        anchorEl={anchorRef.current}
        onClose={() => setOpen(false)}
        open={open}
        sx={{ minWidth: 100, padding: 5, maxWidth: 300 }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>{children}</Box>
      </Popover>
    </>
  );
};
